export default "__VITE_ASSET__DJy5Yh_Y__"